import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { vsOpsApi } from "./api";

function VsOpsLayout({ children, title }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await vsOpsApi.logout();
    } catch {
      /* ignore */
    }
    navigate("/vs-ops/login", { replace: true });
  };

  return (
    <div className="vs-ops-page">
      <header className="vs-ops-header">
        <div className="vs-ops-header-inner">
          <Link to="/vs-ops/sales" className="vs-ops-brand">
            Visoria Ops
          </Link>
          <nav className="vs-ops-nav">
            <NavLink to="/vs-ops/sales">Продажи</NavLink>
            <NavLink to="/vs-ops/warehouse">Склад</NavLink>
            <NavLink to="/vs-ops/stats">Обороты и прибыль</NavLink>
            <NavLink to="/vs-ops/settings">Настройки</NavLink>
          </nav>
          <button type="button" className="vs-ops-logout" onClick={handleLogout}>
            Выйти
          </button>
        </div>
      </header>
      <main className="vs-ops-main">
        {title ? <h1 className="vs-ops-title">{title}</h1> : null}
        {children}
      </main>
    </div>
  );
}

export default VsOpsLayout;
